import { createGlobalStyle } from '@xstyled/styled-components';
import blueJones from '~/assets/fonts/blue-jones.woff2';
import raleway from '~/assets/fonts/Raleway-Regular.woff2';
import recoleta from '~/assets/fonts/Recoleta-Regular.woff2';
import ralewayBold from '~/assets/fonts/Raleway-Bold.woff2';
import recoletaBold from '~/assets/fonts/Recoleta-SemiBold.woff2';

export const DarkStyle = createGlobalStyle`
  @font-face {
    font-family: bluejones;
    src: url(${blueJones});
  }

  @font-face {
    font-family: raleway;
    src: url(${raleway});
  }

  @font-face {
    font-family: recoleta;
    src: url(${recoleta});
  }

  @font-face {
    font-family: ralewayBold;
    src: url(${ralewayBold});
  }

  @font-face {
    font-family: recoletaBold;
    src: url(${recoletaBold});
  }

  :root {
    --color-black: #EFF0F1;
    --color-white: #1A171C;

    --color-grey-dk: #EFEFEF;
    --color-grey-md: #434343;
    --color-grey-lt: #313131;

    --color-accent-dk: #5D07C4;
    --color-accent-md: #9D76FB;
    --color-accent-lt: #5D07C4;

    --color-yellow-dk: #FDD15F;
    --color-yellow-md: #F8EAB7;
    --color-yellow-lt: #E6A601;

    --color-green-dk: #00A876;
    --color-green-md: #92E8BF;
    --color-green-lt: #E8FAED;

    --color-red-dk: #F7326D;
    --color-red-md: #FABCCB;
    --color-red-lt: #FDF2F4;

    --color-blue-md: #0975FD;

    --color-pink-lt: #0D0025;
    --color-pink-lt2: #15002E;

    --title-font: recoleta;
    --body-font: raleway;
    --llama-font: bluejones;
  }

  html, body, .root, #root {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
  }

  a {
    text-decoration: none;
    color: #c4c4c4 !important;
  }

  p {
    margin: 0;
  }

  button {
    cursor: pointer;
  }

  textarea {
    border: none;
    background: var(--color-grey-lt);
    border-radius: md;
  }

  video::-webkit-media-controls {
    display: none;
  }

  .emailStyleForDarkTheme, .envelopeStyleForDarkTheme {
    background-color: #4B4B4B;
  }

  .cardStyleForDarkTheme {
    border: 1px solid #515151;
    box-shadow: rgb(255 255 255 / 20%) 0px 12px 28px 0px, rgb(255 255 255 / 10%) 0px 2px 4px 0px, rgb(255 255 255 / 5%) 0px 0px 0px 1px inset;
  }

  .logoStyleForDarkTheme {
    padding: 2px 5px;
    background-color: #FFFFFF;
    border-radius: 8px;
  }

  .invertStyleForDarkMode {
    filter: invert(93%);
  }

  .itemStyleForDarkTheme {
    color: #FFFFFF !important;
  }

  .subtitleStyleForDarkTheme {
    padding: 5px;
    width: fit-content;
    background-color: #FFFFFF;
    border-radius: 8px;

    svg {
      position: relative;
    }
  }

  .modalStyleForDarkTheme {
    -webkit-border-radius: 20px;
    -moz-border-radius: 20px;
    border-radius: 20px;

    -webkit-box-shadow: rgb(255 255 255 / 20%) 0px 12px 28px 0px, rgb(255 255 255 / 10%) 0px 2px 4px 0px, rgb(255 255 255 / 5%) 0px 0px 0px 1px inset;
    -moz-box-shadow: rgb(255 255 255 / 20%) 0px 12px 28px 0px, rgb(255 255 255 / 10%) 0px 2px 4px 0px, rgb(255 255 255 / 5%) 0px 0px 0px 1px inset;
    box-shadow: rgb(255 255 255 / 20%) 0px 12px 28px 0px, rgb(255 255 255 / 10%) 0px 2px 4px 0px, rgb(255 255 255 / 5%) 0px 0px 0px 1px inset;
  }

  .navigationStyleForDarkTheme {
    -webkit-box-shadow: rgb(255 255 255 / 20%) 0px 12px 28px 0px, rgb(255 255 255 / 10%) 0px 2px 4px 0px, rgb(255 255 255 / 5%) 0px 0px 0px 1px inset;
    -moz-box-shadow: rgb(255 255 255 / 20%) 0px 12px 28px 0px, rgb(255 255 255 / 10%) 0px 2px 4px 0px, rgb(255 255 255 / 5%) 0px 0px 0px 1px inset;
    box-shadow: rgb(255 255 255 / 20%) 0px 12px 28px 0px, rgb(255 255 255 / 10%) 0px 2px 4px 0px, rgb(255 255 255 / 5%) 0px 0px 0px 1px inset;
  }

  .brightnessStyleForDarkTheme {
    filter: brightness(0.7);
  }

  .pointerStyleForDarkTheme {
    filter: invert(93%);
  }

  .timeRemainingPillStyleForDarkTheme {
    color: #FFFFFF;
  }

  .textareaStyleForDarTheme {
    color: #FFFFFF;
    ::placeholder {
      color: #FFFFFF;
      opacity: 1;
    }
    :-ms-input-placeholder {
      color: #FFFFFF;
    }

    ::-ms-input-placeholder {
      color: #FFFFFF;
    }
  }

  .cardBorderStyleForDarkTheme {
    background-color: #FFFFFF !important;
    color: #000000;
  }

  .bgImage, .emptyBgImage {
    filter: brightness(45%);
  }

  .textMessageDarkTheme {
    a {
      color: #FDEF66 !important;
    }
  }

  /* Chatbot dark theme overrides */
  .chatMessageRoot {
    color: #efefef;
  }
  .chatMessageRoot article {
    background-color: transparent;
    color: #efefef;
    border: 1px solid #515151;
  }
  .chatMessageRoot article:before { display: none; }
  .chatMessageRoot code { background: #2d2d2d; color: #f5f5f5; }
  .chatMessageRoot blockquote { background: #1f1f1f; border-left-color: #6a6a6a; }

  /* Differentiate outgoing (user) vs incoming (assistant) in dark mode */
  .chatMessageRoot li[data-type='outgoing'] article {
    background-color: #2f2f2f; /* subtle filled gray */
    color: #ffffff;
    border: 1px solid #3a3a3a;
  }
  .chatMessageRoot li[data-type='outgoing'] article:before {
    display: block;
    border-left-color: #2f2f2f !important;
  }

  /* Incoming (assistant) bubble: transparent with border and left notch */
  .chatMessageRoot li[data-type='incoming'] article {
    background-color: transparent;
    color: #efefef;
    border: 1px solid #515151;
  }
  .chatMessageRoot li[data-type='incoming'] article:before {
    display: block;
    border-right-color: #515151 !important; /* outer border triangle */
    z-index: 1;
    left: -15.5px;
  }
  .chatMessageRoot li[data-type='incoming'] article:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: -12px;
    width: 36px;
    height: 26px;
    border-right: 22px solid var(--color-white); /* inner fill equals container bg */
    border-bottom-right-radius: 100%;
    transform: rotate(-4deg) scale(1.2);
    z-index: 1;
    pointer-events: none;
  }

  /* Safari-specific: hide assistant notch to avoid anti-alias artifacts */
  @supports (-webkit-touch-callout: none) {
    .chatMessageRoot li[data-type='incoming'] article:before,
    .chatMessageRoot li[data-type='incoming'] article:after {
      display: none !important;
    }
  }
  ._AccordionContentBox {
    p {
      color: #000 !important;
    }
    color: #000;
  }

  .text-align-left {
    text-align: left !important;
  }

  .text-align-center {
    text-align: center !important;
  }

  .text-align-right {
    text-align: right !important;
  }

  .text-align-justify {
    text-align: justify !important;
  }
`;
